// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"042771d8","769":"4edd1d78"}[chunkId] + ".chunk.js";
};